import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDevelopmentPath } from "@core/schema/paths/getDevelopmentPath.js";

export function getCrmHowDev(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "V prvním kroku sp[[detailně zmapujeme vaše potřeby a firemní procesy.]] Díky tomu vám pomůžeme zjistit, které části podnikání fungují neefektivně a zohledníme to při návrhu CRM řešení.",
		},
		{
			desc: `Podle vašich požadavků se buď sp[[pustíme do [${getDevelopmentPath(tenant)}][[vývoje]]]] sp[[CRM řešení na míru,]] nebo zajistíme optimalizaci a automatizaci CRM.`,
		},
		{
			desc: "Jakmile si schválíme finální podobu a CRM projde testováním, sp[[přijde řada na jeho implementaci,]] případně také na integraci s dalšími systémy (např. s SCM).",
		},
		{
			desc: "Nasazením to nekončí, rádi vám budeme k ruce jako sp[[dlouhodobá podpora pro údržbu CRM systému.]]",
		},
	];
}
